function formatBadgeDate(value) {
  if (!value) {
    return "--";
  }

  const date = new Date(`${value}T00:00:00`);
  return Number.isNaN(date.getTime()) ? "--" : String(date.getDate());
}

export default function WeekdayScheduleGrid({
  rows = [],
  isEditMode = false,
  isActiveCycle = false,
  selectedWorkoutOrderIndex = null,
  isRecoveringDraft = false,
  onWorkoutRowClick,
}) {
  return (
    <div className="lz-builder-weekday-grid" aria-label="Weekday workout schedule">
      {rows.map((row) => {
        const isSelected = Boolean(
          row.workout &&
          Number(selectedWorkoutOrderIndex) === Number(row.workout.orderIndex)
        );
        const temporalModifier = row.isPastOccurrence
          ? "past"
          : row.isTodayOccurrence
            ? "today"
            : "future";

        return (
          <div
            key={row.day}
            className={[
              "lz-builder-weekday-row",
              `lz-builder-weekday-row--${temporalModifier}`,
              row.workout ? "lz-builder-weekday-row--workout" : "lz-builder-weekday-row--empty",
              isEditMode ? "lz-builder-weekday-row--editing" : "",
              isSelected ? "lz-builder-weekday-row--selected" : "",
            ].filter(Boolean).join(" ")}
            data-date-state={row.dateState}
          >
            <div className="lz-builder-weekday-row__date">
              <span className="lz-builder-weekday-row__date-number">
                {formatBadgeDate(row.calendarDate)}
              </span>
              <span className="lz-builder-weekday-row__day">
                {row.label.slice(0, 3)}
              </span>
            </div>

            {row.workout ? (
              <button
                type="button"
                onClick={() => onWorkoutRowClick?.(row)}
                disabled={isRecoveringDraft}
                className="lz-builder-weekday-row__workout"
                aria-pressed={isEditMode ? isSelected : undefined}
              >
                <span className="lz-builder-weekday-row__heading">
                  <span className="lz-builder-weekday-row__name truncate">
                    {row.workout.name}
                  </span>
                  <span className="lz-builder-weekday-row__badges">
                    {isActiveCycle && row.isPastOccurrence ? (
                      <span className="lz-builder-weekday-row__badge lz-builder-weekday-row__badge--locked">
                        Locked
                      </span>
                    ) : row.isTodayOccurrence ? (
                      <span className="lz-builder-weekday-row__badge lz-builder-weekday-row__badge--today">
                        Today
                      </span>
                    ) : null}
                    <span className="lz-builder-weekday-row__badge">
                      Day {row.workout.orderIndex}
                    </span>
                  </span>
                </span>
                <span className="lz-builder-weekday-row__meta">{row.workout.meta}</span>
              </button>
            ) : (
              <div className="lz-builder-weekday-row__rest">
                <span>Rest day</span>
                {row.isTodayOccurrence ? (
                  <span className="lz-builder-weekday-row__badge lz-builder-weekday-row__badge--today">
                    Today
                  </span>
                ) : null}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
